/* eslint-disable camelcase */
import { getBackVersion } from '../config';
import { RegisterAccessProps } from '../models/VerifyAccess';
import api from './api';

export type VerifyAccessResponse = {
    emailAccessEnabled: boolean;
    hasValidToken: boolean;
    newTokenIssued: boolean;
};

const verifyAccess = (
    resourceType: string,
    resourceId: string,
    accessToken?: string
): Promise<VerifyAccessResponse> =>
    api.request<VerifyAccessResponse>({
        method: 'GET',
        url: `${getBackVersion()}/verify_access`,
        action: 'VERIFY_EMAIL_EXTERNAL_ACCESS',
        params: {
            resource_type: resourceType,
            resource_id: resourceId,
            access_token: accessToken,
        },
    });

const registerAccess = (
    register: RegisterAccessProps
): Promise<VerifyAccessResponse> =>
    api.request<VerifyAccessResponse>({
        method: 'POST',
        url: `${getBackVersion()}/verify_access`,
        action: 'ADD_EMAIL_EXTERNAL_ACCESS',
        params: {
            resource_type: register.resourceType,
            resource_id: register.resourceId,
            email: register.email,
            doc: register.document,
            access_code: register.accessCode,
        },
    });

export default {
    verifyAccess,
    registerAccess,
};
